import { GetterTree } from "vuex";
import { RootState } from "../types";
import { TalentsState } from "./types";

export const getters: GetterTree<TalentsState, RootState> = {
  getIds(state): Array<string> {
    return state.ids;
  },
};
